import { Component, EventEmitter, Input, effect, signal } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { ProfilConfigurationSaisieDonneesAnalyse } from '../../bo/profilConfigurationSaisieDonneesAnalyse';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { ConfigDonneesAnalyseModaleComponent } from '../config-donnees-analyse-modale/config-donnees-analyse-modale.component';
import { ConfigurationSaisieDonneesAnalyse, ModeSaisie } from 'src/app/bo/configurationSaisieDonneesAnalyse';
import { GridListComponentKpi } from '../Grid-List/grid-list-kpi.component';
import { ReferentielDonneeAnalyse } from 'src/app/bo/referentielDonneeAnalyse';
import { KpiService } from 'src/app/services/kpi.service';

@Component({
  selector: 'app-config-donnees-analyse',
  templateUrl: './config-donnees-analyse.component.html',
  styleUrls: ['./config-donnees-analyse.component.scss'],
  // imports: [GridListComponentKpi],
  standalone: false
})

export class ConfigDonneesAnalyseComponent {
  modalModif: BsModalRef;
  proprietesAfficheesConfig: ProprieteAffichee[];
  tabConfig = signal<ConfigurationSaisieDonneesAnalyse[]>([]);
  tabConfigSauv = signal<ConfigurationSaisieDonneesAnalyse[]>([]);
  tabProfils = signal<ProfilConfigurationSaisieDonneesAnalyse[]>([]);
  tabConfigProfils = signal<ConfigurationSaisieDonneesAnalyse[]>([]);
  tabModeSaisieProjet = signal<any[]>([]);
  profilSelectionne: ProfilConfigurationSaisieDonneesAnalyse;
  success = false;
  erreurRecuperation = signal(false);
  listeModifiee = new EventEmitter<any>();
  siteCurrency: string;

  constructor(private readonly http: HttpService, private readonly modalService: BsModalService, private readonly utilService: UtilisateurService, private readonly fonctionsService: FonctionsService,
    private readonly traductionService: TraductionService, private readonly kpiService: KpiService) {
    this.proprietesAfficheesConfig = new ConfigurationSaisieDonneesAnalyse().getProprietesAffichees();
    this.modalService.onHide.observers = [];
    this.modalService.onHide.subscribe((val: any) => {
      if (this.modalModif && this.modalModif.content && !this.modalModif.content.annul == true && val != "esc") {
        var configIndex = this.tabConfig().findIndex(p => p.siteId == this.modalModif.content.config.siteId
          && p.referentielDonneeAnalyse.referentielDonneeAnalyseId == this.modalModif.content.config.referentielDonneeAnalyse.referentielDonneeAnalyseId);
        const updated = [...this.tabConfig()];
        Object.assign(updated[configIndex], this.modalModif.content.config);
        this.tabConfig.set(updated);
        const updatedSauv = [...this.tabConfigSauv()];
        Object.assign(updatedSauv[configIndex], this.modalModif.content.config);
        this.tabConfigSauv.set(updatedSauv);
        this.listeModifiee.emit(true);
        this.modalModif = null;
      }
    });

    effect(() => { this.utilService.currentSite(); this.refreshData(); });
    this.siteCurrency = this.utilService.currentSite().currency;
  }

  ngOnInit() {
    this.traductionService.translate.get(['GLOBAL.MOYENNE', 'GLOBAL.SOMME', 'GLOBAL.MINIMUM', 'GLOBAL.MAXIMUM', 'GLOBAL.MANUELLE']).subscribe(traduction => {
      this.tabModeSaisieProjet.set([
        { nom: traduction['GLOBAL.MANUELLE'], val: ModeSaisie.Manuelle },
        { nom: traduction['GLOBAL.SOMME'], val: ModeSaisie.Somme },
        { nom: traduction['GLOBAL.MOYENNE'], val: ModeSaisie.Moyenne },
        { nom: traduction['GLOBAL.MINIMUM'], val: ModeSaisie.Min },
        { nom: traduction['GLOBAL.MAXIMUM'], val: ModeSaisie.Max }]);
      this.refreshData();
    });
  }

  refreshData() {
    this.erreurRecuperation.set(false);
    this.fonctionsService.loading_screen(true);

    let configSite = this.kpiService.getSiteConfigAnalysisEntry(this.utilService.currentSite().siteId);
    let profils = this.http.get<ProfilConfigurationSaisieDonneesAnalyse[]>('Profiles');
    let configProfils = this.http.get<ConfigurationSaisieDonneesAnalyse[]>('Profiles/ConfigAnalysisEntry');

    forkJoin([configSite, profils, configProfils]).subscribe(resultats => {
      resultats[0].forEach((p: ConfigurationSaisieDonneesAnalyse) => p.txtModeSaisieDonneeProjet = this.tabModeSaisieProjet().find(o => o.val == p.modeSaisieDonneeProjet)?.nom);
      this.tabConfig.set(Object.assign([], resultats[0]));
      const configProfilsData = resultats[2];
      configProfilsData.forEach((p: ConfigurationSaisieDonneesAnalyse) => p.txtModeSaisieDonneeProjet = this.tabModeSaisieProjet().find(o => o.val == p.modeSaisieDonneeProjet).nom);
      this.tabConfigProfils.set(configProfilsData);

      this.tabConfigSauv.set(JSON.parse(JSON.stringify(resultats[0])));
      this.tabProfils.set(resultats[1]);
      this.fonctionsService.loading_screen(false);

    }, () => {
      this.erreurRecuperation.set(true);
      this.fonctionsService.loading_screen(false);
    });
  }

  ouvrirModale(config: ConfigurationSaisieDonneesAnalyse) {
    if (this.profilSelectionne) {
      this.annulModif();
    }

    let configuration = new ConfigurationSaisieDonneesAnalyse();
    // Permet d'éviter que la modification dans la modale se répercute en live dans la liste
    Object.assign(configuration, config);
    var initialState = {
      config: configuration
    };
    this.modalModif = this.modalService.show(ConfigDonneesAnalyseModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState });
  }

  changerProfil() {
    let tabConfigRestaure = [];
    if (this.profilSelectionne)
      Object.assign(tabConfigRestaure, this.tabConfigProfils().filter(o => o.profilId == this.profilSelectionne.profilId));
    else
      Object.assign(tabConfigRestaure, this.tabConfigSauv());

    this.tabConfig().forEach((config) => {
      let index = tabConfigRestaure.findIndex(o => o.referentielDonneeAnalyse.referentielDonneeAnalyseId == config.referentielDonneeAnalyse.referentielDonneeAnalyseId);
      if (index != -1) {
        config.isEnabled = tabConfigRestaure[index].isEnabled;
        config.valeurNominal = tabConfigRestaure[index].valeurNominal;
        config.valeurMin = tabConfigRestaure[index].valeurMin;
        config.valeurMax = tabConfigRestaure[index].valeurMax;
        config.modeSaisieDonneeProjet = tabConfigRestaure[index].modeSaisieDonneeProjet;
        config.txtModeSaisieDonneeProjet = tabConfigRestaure[index].txtModeSaisieDonneeProjet;
      }
    });
  }

  annulModif() {
    this.profilSelectionne = null;
    this.changerProfil();
  }

  onSubmit() {
    this.fonctionsService.loading_screen(true);
    this.http.post<ConfigurationSaisieDonneesAnalyse[], ConfigDonneesAnalyseComponent>('ConfigAnalysisEntry', this.tabConfig()).subscribe(resultat => {
      this.success = true;
      const updatedConfig = JSON.parse(JSON.stringify(resultat));
      updatedConfig.forEach((conf: ConfigurationSaisieDonneesAnalyse) => {
        this.traductionService.translate.get(conf.referentielDonneeAnalyse.nom).subscribe(translation => conf.referentielDonneeAnalyse.nom = translation);
        conf.txtModeSaisieDonneeProjet = this.tabModeSaisieProjet().find(o => o.val == conf.modeSaisieDonneeProjet).nom;
      });
      this.tabConfig.set(updatedConfig);

      this.tabConfigSauv.set(JSON.parse(JSON.stringify(resultat)));
      this.profilSelectionne = null;
      this.fonctionsService.launch_toast(this.success);
      this.fonctionsService.loading_screen(false);
    }, () => {
      this.success = false;
      this.fonctionsService.launch_toast(this.success);
      this.fonctionsService.loading_screen(false);
    });
  }
}
